/**
* 生产商
*/
const manufacturer = {
  
addManufacturer: "/api/addManufacturer",//新增生产商
modifyManufacturer: "/api/modifyManufacturer",//修改生产商
getManufacturer: "/api/getManufacturer",//查询生产商
getManufacturer2: "/api/getManufacturer2",//查询生产商
deleteManufacturer: "/api/deleteManufacturer",//删除生产商
addDeviceModel: "/api/addDeviceModel",//新增设备型号
modifyDeviceModel: "/api/modifyDeviceModel",//修改设备型号
getDeviceModel: "/api/getDeviceModel",//查询设备型号
getDeviceModel2: "/api/getDeviceModel2",//查询设备型号
getDeviceModel3: "/api/getDeviceModel3",//查询设备型号
deleteDeviceModel: "/api/deleteDeviceModel",//删除设备型号
}

export default manufacturer